import React, { useState } from 'react';
import { 
  FaMotorcycle, 
  FaCar, 
  FaCalendarAlt, 
  FaClock, 
  FaUser, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaArrowRight,
  FaCheckCircle,
  FaWrench,
  FaShieldAlt,
  FaWhatsapp,
  FaStar,
  FaTools,
  FaOilCan,
  FaBatteryFull,
  FaTachometerAlt,
  FaSnowflake,
  FaCogs,
  FaRocket,
  FaGift,
  FaHeadset,
  FaRegClock
} from 'react-icons/fa';
import { GiGearHammer, GiCarKey, GiMechanicGarage } from 'react-icons/gi';

const BookService = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState('bike');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    vehicleType: 'bike',
    vehicleModel: '',
    serviceType: '',
    date: '',
    time: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleVehicleSelect = (type) => {
    setSelectedVehicle(type);
    setFormData({
      ...formData,
      vehicleType: type
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '',
        phone: '',
        email: '',
        address: '',
        vehicleType: 'bike',
        vehicleModel: '',
        serviceType: '',
        date: '',
        time: '',
        message: ''
      });
    }, 3000);
  };

  const bikeServices = [
    { name: 'General Servicing', icon: <FaWrench />, price: '₹499', duration: '1-2 hrs' },
    { name: 'Engine Repair', icon: <GiGearHammer />, price: '₹999', duration: '2-3 hrs' },
    { name: 'Oil Change', icon: <FaOilCan />, price: '₹299', duration: '30 min' },
    { name: 'Brake Repair', icon: <FaTools />, price: '₹399', duration: '1 hr' },
    { name: 'Battery Check', icon: <FaBatteryFull />, price: '₹199', duration: '30 min' },
    { name: 'Full Checkup', icon: <FaTachometerAlt />, price: '₹599', duration: '2 hrs' }
  ];

  const carServices = [
    { name: 'General Servicing', icon: <FaWrench />, price: '₹1999', duration: '3-4 hrs' },
    { name: 'Engine Repair', icon: <GiGearHammer />, price: '₹2999', duration: '4-5 hrs' },
    { name: 'Oil Change', icon: <FaOilCan />, price: '₹999', duration: '1 hr' },
    { name: 'Brake Repair', icon: <FaTools />, price: '₹1199', duration: '2 hrs' },
    { name: 'AC Service', icon: <FaSnowflake />, price: '₹1499', duration: '2 hrs' },
    { name: 'Full Checkup', icon: <FaCogs />, price: '₹2499', duration: '4 hrs' }
  ];

  const serviceOptions = selectedVehicle === 'bike' ? bikeServices : carServices;

  const benefits = [
    { icon: <FaShieldAlt />, title: 'Genuine Parts', desc: '100% authentic spare parts', color: 'from-blue-500 to-blue-600' },
    { icon: <FaRocket />, title: 'Quick Service', desc: 'Same day delivery', color: 'from-orange-500 to-orange-600' },
    { icon: <GiCarKey />, title: 'Free Pickup', desc: 'Within 5km radius', color: 'from-green-500 to-green-600' },
    { icon: <FaStar />, title: 'Expert Team', desc: 'Certified mechanics', color: 'from-purple-500 to-purple-600' }
  ];

  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header - More Attractive */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-100 to-red-50 px-5 py-2 rounded-full mb-4 shadow-sm">
            <FaWrench className="text-red-500 text-xs" />
            <span className="text-red-600 font-semibold text-xs uppercase tracking-wider">Express Booking</span>
            <FaRocket className="text-red-500 text-xs" />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
            Book Your <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">Service</span> Today!
          </h1>
          <p className="text-gray-500 max-w-xl mx-auto text-sm">
             Instant confirmation •  Expert mechanics •  Quality assured
          </p>
          <div className="flex justify-center gap-2 mt-4">
            <div className="w-12 h-0.5 bg-red-500 rounded-full"></div>
            <div className="w-4 h-0.5 bg-red-400 rounded-full"></div>
            <div className="w-2 h-0.5 bg-red-300 rounded-full"></div>
          </div>
        </div>

        {/* Offer Banner - New */}
        <div className="mb-8 bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-3 shadow-lg">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <div className="flex items-center gap-3">
              <FaGift className="text-white text-xl" />
              <div>
                <p className="text-white font-bold text-sm"> First Service @ 20% OFF</p>
                <p className="text-red-100 text-xs">Use code: FIRST20</p>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full">
              <FaRegClock className="text-white text-xs" />
              <span className="text-white text-xs font-medium">Limited period offer</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left Side - Form */}
          <div className="w-full lg:w-2/3">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              <div className="bg-gradient-to-r from-red-600 to-red-700 px-5 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-white font-bold text-lg flex items-center gap-2">
                      <GiMechanicGarage className="text-yellow-300" />
                      Quick Service Booking
                    </h3>
                    <p className="text-red-100 text-xs mt-0.5">Fill details & get instant confirmation </p>
                  </div>
                  <div className="bg-white/20 px-3 py-1 rounded-full">
                    <span className="text-white text-xs font-semibold"> 2 min form</span>
                  </div>
                </div>
              </div>
              
              <div className="p-5 md:p-6">
                {formSubmitted ? (
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6 text-center">
                    <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                      <FaCheckCircle className="text-white text-2xl" />
                    </div>
                    <h3 className="text-green-700 font-bold text-lg mb-1"> Booking Confirmed!</h3>
                    <p className="text-green-600 text-sm mb-3">Thank you for choosing Ambris Service Center.</p>
                    <div className="bg-white rounded-lg p-3 mb-3">
                      <p className="text-gray-600 text-xs">📞 We'll call you within <strong className="text-green-600">30 minutes</strong> to confirm</p>
                    </div>
                    <p className="text-gray-500 text-xs"> Expect a confirmation call soon </p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Vehicle Type Selection - Improved */}
                    <div>
                      <label className="block text-gray-700 font-semibold text-sm mb-2">Select Vehicle *</label>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={() => handleVehicleSelect('bike')}
                          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl border-2 transition-all duration-300 text-sm font-semibold ${
                            selectedVehicle === 'bike'
                              ? 'border-red-500 bg-gradient-to-r from-red-50 to-red-100 text-red-600 shadow-md'
                              : 'border-gray-200 bg-white text-gray-500 hover:border-red-300 hover:bg-red-50'
                          }`}
                        >
                          <FaMotorcycle className="text-base" />
                          <span> Bike</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => handleVehicleSelect('car')}
                          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl border-2 transition-all duration-300 text-sm font-semibold ${
                            selectedVehicle === 'car'
                              ? 'border-red-500 bg-gradient-to-r from-red-50 to-red-100 text-red-600 shadow-md'
                              : 'border-gray-200 bg-white text-gray-500 hover:border-red-300 hover:bg-red-50'
                          }`}
                        >
                          <FaCar className="text-base" />
                          <span>Car</span>
                        </button>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5">Full Name *</label>
                        <div className="relative">
                          <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                            placeholder="Enter your name"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5">📞 Phone Number *</label>
                        <div className="relative">
                          <FaPhoneAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                            placeholder="+91 8081321406"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5"> Email</label>
                        <div className="relative">
                          <FaEnvelope className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                            placeholder="your@email.com"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5"> Vehicle Model *</label>
                        <div className="relative">
                          <GiMechanicGarage className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="text"
                            name="vehicleModel"
                            value={formData.vehicleModel}
                            onChange={handleChange}
                            required
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                            placeholder={selectedVehicle === 'bike' ? 'e.g., Royal Enfield' : 'e.g., Maruti Suzuki'}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Service Type - Improved */}
                    <div>
                      <label className="block text-gray-700 text-xs font-medium mb-1.5"> Select Service *</label>
                      <select
                        name="serviceType"
                        value={formData.serviceType}
                        onChange={handleChange}
                        required
                        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all bg-white"
                      >
                        <option value="">Choose a service</option>
                        {serviceOptions.map((service, idx) => (
                          <option key={idx} value={service.name}>{service.name} - {service.price} ({service.duration})</option>
                        ))}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5"> Preferred Date *</label>
                        <div className="relative">
                          <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            required
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-gray-700 text-xs font-medium mb-1.5"> Preferred Time *</label>
                        <div className="relative">
                          <FaClock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="time"
                            name="time"
                            value={formData.time}
                            onChange={handleChange}
                            required
                            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all"
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <label className="block text-gray-700 text-xs font-medium mb-1.5"> Address (Free pickup)</label>
                      <div className="relative">
                        <FaMapMarkerAlt className="absolute left-3 top-3 text-gray-400 text-xs" />
                        <textarea
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          rows="2"
                          className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all resize-none"
                          placeholder="Enter your address for free pickup service"
                        ></textarea>
                      </div>
                    </div>
                    

                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white py-2.5 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center gap-2 text-sm shadow-md hover:shadow-lg"
                    >
                      ✅ Confirm Booking
                      <FaArrowRight className="text-xs" />
                    </button>

                    <div className="flex items-center justify-center gap-3 text-xs text-gray-400">
                      <span> Secure</span>
                      <span>Instant</span>
                      <span> Free cancellation</span>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>

          {/* Right Side - Compact & Attractive */}
          <div className="w-full lg:w-1/3">
            {/* Benefits - Compact Grid */}
            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-4 border border-red-100 shadow-md mb-5">
              <h3 className="text-base font-bold text-gray-800 mb-3 flex items-center gap-2">
                <FaStar className="text-red-500 text-sm" />
                Why Choose Us? 
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {benefits.map((benefit, idx) => (
                  <div key={idx} className="bg-white rounded-lg p-2 text-center shadow-sm">
                    <div className="w-8 h-8 mx-auto bg-gradient-to-r rounded-lg flex items-center justify-center text-white text-sm mb-1 shadow-sm" style={{ background: `linear-gradient(135deg, ${benefit.color.split(' ')[1]}, ${benefit.color.split(' ')[3]})` }}>
                      {benefit.icon}
                    </div>
                    <h4 className="font-semibold text-gray-800 text-xs">{benefit.title}</h4>
                    <p className="text-gray-500 text-[10px]">{benefit.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Popular Services - Compact */}
            <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-md mb-5">
              <h3 className="text-base font-bold text-gray-800 mb-3 flex items-center gap-2">
                <FaWrench className="text-red-500 text-sm" />
                 Popular {selectedVehicle === 'bike' ? 'Bike' : 'Car'} Services
              </h3>
              <div className="space-y-1.5">
                {serviceOptions.slice(0, 4).map((service, idx) => (
                  <div key={idx} className="flex justify-between items-center py-1.5 border-b border-gray-50">
                    <div className="flex items-center gap-2">
                      <span className="text-red-500 text-xs">{service.icon}</span>
                      <span className="text-gray-700 text-xs">{service.name}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-gray-400 text-[10px]">{service.duration}</span>
                      <span className="text-red-600 font-bold text-xs">{service.price}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-3 pt-2 border-t border-gray-100">
                <p className="text-gray-500 text-[10px] text-center">+6 more services available</p>
              </div>
            </div>

            {/* Contact Card - Compact */}
            <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-4 text-white shadow-md">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base font-bold flex items-center gap-2">
                  <FaHeadset className="text-red-500 text-sm" />
                  Need Help? 
                </h3>
                <div className="bg-green-500/20 px-2 py-0.5 rounded-full">
                  <span className="text-green-400 text-[10px] font-semibold">24/7 Support</span>
                </div>
              </div>
              <p className="text-gray-300 text-xs mb-3">Call or WhatsApp for instant assistance</p>
              <div className="space-y-2 mb-3">
                <a href="tel:+918081321406" className="flex items-center justify-between bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors">
                  <div className="flex items-center gap-2">
                    <FaPhoneAlt className="text-red-500 text-xs" />
                    <span className="text-sm font-semibold">+91 8081321406</span>
                  </div>
                  <span className="text-green-400 text-[10px]">Call Now 📞</span>
                </a>
                <a href="https://wa.me/918081321406" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors">
                  <div className="flex items-center gap-2">
                    <FaWhatsapp className="text-green-500 text-sm" />
                    <span className="text-sm font-semibold">WhatsApp Us</span>
                  </div>
                  <span className="text-green-400 text-[10px]">Chat </span>
                </a>
              </div>
              <div className="pt-2 border-t border-gray-700">
                <div className="flex justify-between text-[10px] text-gray-400">
                  <span> Mon-Sun: 9AM-7PM</span>
                  <span> Free pickup*</span>
                </div>
              </div>
            </div>

            {/* Trust Badge */}
            <div className="mt-4 text-center">
              <div className="flex items-center justify-center gap-2">
                <div className="flex -space-x-1">
                  <div className="w-5 h-5 bg-gray-200 rounded-full border-2 border-white"></div>
                  <div className="w-5 h-5 bg-gray-300 rounded-full border-2 border-white"></div>
                  <div className="w-5 h-5 bg-gray-400 rounded-full border-2 border-white"></div>
                </div>
                <p className="text-gray-500 text-[10px]">Trusted by <strong className="text-red-600">5000+</strong> happy customers</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookService;